import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import { MeasureInputResult } from 'cd-eft/business/MapViewInputManager/MeasureInputResult';
import { action, observable } from 'mobx';

export class MeasureResultsModel {
  private measuresGroupLayer: GroupLayer;
  @observable activeFeedback: MeasureInputResult | undefined;
  @observable readonly completedMeasures: MeasureInputResult[];

  get displayResult(): MeasureInputResult | undefined {
    if (this.activeFeedback) {
      return this.activeFeedback;
    }
    else {
      return undefined;
    }
  }

  constructor(measuresGroupLayer: GroupLayer) {
    this.measuresGroupLayer = measuresGroupLayer;
    this.activeFeedback = undefined;
    this.completedMeasures = [];
  }

  @action.bound addResult(result: MeasureInputResult) {
    this.activeFeedback = result;
    this.completedMeasures.push(result);

    const layer = this.constructResultLayer(result);
    this.measuresGroupLayer.add(layer);
  }

  @action.bound clearResults() {
    this.activeFeedback = undefined;
    this.completedMeasures.splice(0, this.completedMeasures.length);

    this.measuresGroupLayer.removeAll();
  }

  private constructResultLayer(result: MeasureInputResult) {
    const layer = new GraphicsLayer();
    layer.title = result.type;
    const graphics = result.generateGraphics();
    layer.addMany(graphics);
    return layer;
  }
}
